import React, { useContext, useState, useEffect } from 'react';
import { UserContext } from '../../UserContext';
import { useNavigate } from 'react-router-dom';
import FormActionButton from '../../components/FormActionButton';
import { validatePassword, PasswordValidationResult, identifyPasswordValidationResult } from './validatePassword';
import PasswordValidationView from './PasswordValidationView';
import Container from '../../components/Container';
import Heading2 from '../../components/Heading2';

const CreatePasswordScreen: React.FC = () => {
  const userContext = useContext(UserContext);
  const [password, setPassword] = useState(userContext?.userData.password || '');
  const [validationResult, setValidationResult] = useState<PasswordValidationResult>(identifyPasswordValidationResult);
  const [isPasswordValid, setIsPasswordValid] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const result = validatePassword(password);
    setValidationResult(result);

    // Check if all validation rules are passed
    const allValid = Object.values(result).every(Boolean);
    setIsPasswordValid(allValid);
  }, [password]);

  if (!userContext) return null;

  const { userData, setUserData } = userContext;

  const handleFormSubmit = async () => {
    if (!isPasswordValid) return;
    setUserData({ ...userData, password });
    navigate('/personal-info');
  };

  return (
    <Container>
      <Heading2>Create Your Password</Heading2>
      <p className="text-gray-700 mb-6">
        Once you've completed your booking, you'll be able to sign in with your email address and the password you
        create to access your medical history and other forms, appointment history, and schedule new appointments.
      </p>
      <div className="mb-6 relative">
        <div className="flex items-center w-full border-b-2 border-black py-[.5rem]">
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="flex-grow w-full appearance-none text-gray-700 p-2"
            placeholder="Password"
          />
        </div>
      </div>
      <div className="flex justify-center mt-8">
        <PasswordValidationView validationResult={validationResult} />
      </div>
      <div className="flex justify-center mt-8">
        <FormActionButton
          testId="create-password-button"
          onClick={handleFormSubmit}
          isLoading={false}
          disabled={!isPasswordValid}
        >
          Create My Account
        </FormActionButton>
      </div>
    </Container>
  );
};

export default CreatePasswordScreen;
